



































import { Vue, Component, Mixins } from "vue-property-decorator";
import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("club/edit", {
              id: this.editId,
              ...values
            });

            if (res && res.Message && res.Message === "success") {
              this.$message.success("操作成功");
              this.handleCancel();
            } else {
              this.$message.error("操作失败");
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("club/detail", {
      id: this.editId
    });

    if (res && res.Data) {
      this.formData = res.Data;
    }
    this.spinLoading = false;
  }
}
